import { ADOBE_PREVIOUS_PAGE_COOKIE_NAME } from "./constants";
import sdkProvider from "./sdkProvider";

export default () => {
  const { appMeasurementInstance } = sdkProvider();

  return appMeasurementInstance.Util.cookieRead(
    ADOBE_PREVIOUS_PAGE_COOKIE_NAME
  );
};
